import './index.scss';

import { Component } from 'react';

import { BraxUncontrolledToggleField, BraxUncontrolledToggleFieldProps } from '../BraxUncontrolledToggleField';

export type BraxUncontrolledSwitchFieldProps = Omit<BraxUncontrolledToggleFieldProps, 'type'>;

export class BraxUncontrolledSwitchField extends Component<BraxUncontrolledSwitchFieldProps> {

    static defaultProps = {
        disabled: false,
        status: null
    };

    render() {
        return (
            <div className="brax-switch">
                <BraxUncontrolledToggleField type="switch" {...this.props} />
            </div>
        );
    }

}
